import type { Feature } from '../types';
import { Region, FeatureName, ApplicationChannel } from '../config';
import { Adapters } from '../adapters';

/**
 * Zippay configuration
 * zippay inline messaging widget doc:https://developers.zip.co/docs/product-cart-widget#product-page-messaging-implementation
 */
const zippay: Feature = {
  featureName: FeatureName.ZIPPAY,
  description: 'Zippay configuration',
  enabledRegions: [Region.AU],
  enabledAppChannels: [ApplicationChannel.WEB],
  status: true,
  payload: {
    publicKey: Adapters.zipPublicKey,
  },
};

export default zippay;
